/**
 * PATH: apps/quote/src/components/builder/panels/inspector/PlantTab.tsx
 * PURPOSE: Plant & equipment tab for the row inspector
 */

import { formatCurrency } from '@/lib/utils'
import type { QuoteLineItem } from '@/lib/quoteApi'

export default function PlantTab({ lineItem }: { lineItem: QuoteLineItem }) {
  return (
    <div className="p-3 space-y-3">
      <div>
        <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Plant & Equipment</h3>
        <p className="text-xs text-slate-500 dark:text-slate-400">
          Scaffolding, access equipment, and other plant
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
            Unit Cost
          </label>
          <input
            type="number"
            defaultValue={lineItem.plant_unit_cost || 0}
            className="w-full px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
            Quantity
          </label>
          <input
            type="number"
            defaultValue={lineItem.plant_quantity || 0}
            className="w-full px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-sm"
          />
        </div>
      </div>

      <div className="p-2.5 bg-slate-100 dark:bg-slate-800 rounded-lg space-y-1">
        <div className="flex justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Plant Cost:</span>
          <span className="font-medium text-slate-900 dark:text-white">
            {formatCurrency(lineItem.plant_cost || 0)}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Chargeout:</span>
          <span className="font-medium text-emerald-600">
            {formatCurrency(lineItem.plant_chargeout || 0)}
          </span>
        </div>
      </div>
    </div>
  )
}
